module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_5-8b394f6e52c2d0923ce7722f31cea6eb.jpg";